import React, { useState } from "react";
import { Drawer, Form } from "antd";

export default ({ detail }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a onClick={() => setOpen(true)}>查看详情</a>
      <Drawer
        title="详情"
        width={500}
        destroyOnHidden
        open={open}
        onClose={() => setOpen(false)}
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Form.Item label="ID">{detail.id}</Form.Item>
          <Form.Item label="敏感词">{detail.sensitiveWord}</Form.Item>
          <Form.Item label="等级">{detail.level}</Form.Item>
          <Form.Item label="创建时间">{detail.createDate}</Form.Item>
          <Form.Item label="状态">{detail.status}</Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
